import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  users:[],
  rool: null,
  token: null,
  loading: false,
  status: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("rool");
      state.user = null;
      state.token = null;
      state.status = null;
    },
    registerUser(state, action) {
      state.loading = false;
      state.status = action.payload.message;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.loading = true;
    },
    loginUser(state, action) {
      state.loading = false;
      state.status = action.payload.message;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.loading = true;
    },
    getMe(state, action) {
      state.loading = false;
      state.status = null;
      state.user = action.payload?.user;
      state.token = action.payload?.token;
      state.loading = true;
    },
    getAllUsers(state, action) {
      state.loading = false;
      state.users = action.payload;
      state.loading = true;
    },
    loading(state, action) {
      state.loading = action.payload;
    },
  },
});

// Базовые селекторы
export const checkIsAuth = (state) => Boolean(localStorage.getItem("token"));

// Мемоизированные селекторы
export const selectAuthState = state => state.authFile;

export const selectUser = (state) => state.authFile.user;

export const checkIsName = (state) => state.authFile.user;

export const checkIsUser = (state) => state.authFile.user;
export const checkIsRool = (state) => String(localStorage.getItem("rool"));
export default authSlice.reducer;
export const { registerUser, loginUser, getMe, logout, getAllUsers } = authSlice.actions;
